type SignedInState<U> = {
  isAuthenticated: true;
  user: U;
};

type SignedOutState = {
  isAuthenticated: false;
  user: null;
};

export type AuthState<U> = SignedInState<U> | SignedOutState;

export class BaseAuthenticationService<S extends AuthState<unknown>> {
  protected _state: S;
  protected _initial_state: S;

  constructor(initialState: S) {
    this._state = initialState;
    this._initial_state = initialState;
  }

  private _subscription: VoidFunction | null = null;

  public set state(state: S) {
    this._state = state;
    this._subscription && this._subscription();
  }

  public set user(user: S['user']) {
    this.state = {
      ...this._state,
      user,
      isAuthenticated: true,
    };
  }

  signin(user: S['user'], callback?: VoidFunction): void {
    this.state = {
      ...this._state,
      user,
      isAuthenticated: true,
    };

    callback && callback();
  }

  signout(callback?: VoidFunction): void {
    this.state = { ...this._initial_state };

    callback && callback();
  }

  subscribe = (callback: VoidFunction): VoidFunction => {
    this._subscription = callback;
    return () => {
      this._subscription = null;
    };
  };

  getSnapshot = (): S => {
    return this._state;
  };
}
